import React, { Component } from 'react';
import { browserHistory } from 'react-router';

class ContinueBooking extends Component {
    constructor(props) {
        super(props);

        this.handleYes = this.handleYes.bind(this);
        this.handleNo = this.handleNo.bind(this);
    }

    handleYes() {
        const { contactDetails, updateContacts } = this.props;

        updateContacts(contactDetails.jobId, contactDetails);
    }

    handleNo() {
        const { contactDetails, updateContacts } = this.props;

        updateContacts(contactDetails.jobId, { ...contactDetails, sendSMS: true });
    }

    handleHome() {
        browserHistory.push("/");
    }

    render() {
        const { contactDetails: { contact, phoneNumber }, smsSent } = this.props;

        if (smsSent) {
            return (
                <div>
                    <div className="card text-center">
                        An SMS will be sent to <b>{contact}</b> on <b>{phoneNumber}</b> for them to complete the booking.
                    </div>
                    <button type="button" className="btn btn-client btn-lg col-xs-12 m-t-10" onClick={this.handleHome}>
                        <i className="fa fa-home m-r-5" /> Home
                    </button>
                </div>
            );
        }

        return (
            <div>
                <h2>How would you like to continue?</h2>
                <button type="button" className="btn btn-client btn-lg col-xs-12 m-t-10" onClick={this.handleYes}>
                    Proceed with Booking
                </button>
                <h3 className="text-center m-t-10 m-b-10 col-xs-12">OR</h3>
                <button type="button" className="btn btn-client btn-lg col-xs-12" onClick={this.handleNo}>
                    SMS <b>{contact}</b> to Book
                </button>
            </div>
        );
    }
}

export default ContinueBooking;


// WEBPACK FOOTER //
// ./app/address/components/continueBooking.js